import React, { memo } from 'react';
import { useDispatch } from 'react-redux';

import EditableItem from '../../EditableItem/EditableItem';

import editDocumentActions from '../../store/actions/edit-document.actions';
import documentEditMode from '../../constants/documentEditMode';
import PersonWithPosition from '../../PersonWithPosition/PersonWithPosition';

const ResponsibleWorkerCell = memo(
  ({ record, getPopupContainer = () => document.body }) => {
    const dispatch = useDispatch();

    return (
      <EditableItem
        editText="Сменить ответственного"
        record={record}
        onClick={(e) => {
          e.stopPropagation();
          dispatch(
            editDocumentActions.openModal({
              ...record,
              editMode: documentEditMode.RESPONSIBLE_WORKER,
            })
          );
        }}
        itemText={<PersonWithPosition person={record.responsibleWorker} />}
        getPopupContainer={getPopupContainer}
      />
    );
  }
);

export default ResponsibleWorkerCell;
